// https://developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock
if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStockForm extends HTMLElement {
      constructor() {
        super();
        this.formattedNumber;
      }

      connectedCallback() {
        this.form = this.querySelector('#back-in-stock-form');
        this.submitButton = this.querySelector('#back-in-stock-submit-button');
        this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));

        this.emailInput = this.querySelector('#back-in-stock-email');
        this.phoneInput = this.querySelector('#back-in-stock-phone');

        this.signupForNewsletter = this.querySelector('#back-in-stock-newsletter-signup');
        this.signupForSMS = this.querySelector('#back-in-stock-sms-signup');

        this.submitButtonText = this.submitButton?.querySelector('span');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.resetErrorMessages();

        if (!this.phoneInput.value && !this.emailInput.value) {
          this.handleErrorMessage('You must enter either a phone number or an email address');
          return;
        }

        if (this.phoneInput.value) {
          this.formattedNumber = this.formatPhoneNumberForKlaviyo(this.phoneInput.value);
          console.log(this.formattedNumber);
          if (!this.formattedNumber) {
            this.handleErrorMessage('Please enter a valid phone number', this.phoneInput.parentElement);
            return;
          }
        }

        // Make sure the user has provided the relevant info for marketing opt-ins
        if (
          (this.signupForNewsletter.checked && !this.emailInput.value) ||
          (this.signupForSMS.checked && !this.formattedNumber)
        ) {
          this.handleErrorMessage('Something went wrong. Please double check your submission and try again');
          return;
        }

        if (this.emailInput.value && !this.emailInput.checkValidity()) {
          this.handleErrorMessage('Please enter a valid email address', this.emailInput.parentElement);
          console.log(this.emailInput.parentElement);
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButtonText.classList.add('hidden');
        this.submitButton.querySelector('.loading-spinner').classList.remove('hidden');

        const payload = this.buildKlaviyoBiSPayload();

        var requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-04-15',
          },
          body: JSON.stringify(payload),
        };

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=KVDNKn', requestOptions)
          .then(async (result) => {
            if (result.ok) {
              this.form.innerHTML = '<p class="mt-10 uppercase font-medium tracking-[1px]">O yay, you’re all set</p>';
              this.subscribeToKlaviyo();
            } else {
              const { errors } = await result.json();
              this.handleErrorMessage(errors[0].detail);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading-spinner').classList.add('hidden');
            this.submitButtonText.classList.remove('hidden');
          });
      }

      handleErrorMessage(errorMessage = false, errorMessageWrapperEl = null) {
        if (this.hideErrors) return;

        if (errorMessageWrapperEl) {
          this.errorMessageWrapper = errorMessageWrapperEl;
          this.errorMessageWrapper.querySelector('input').focus();
        } else {
          this.errorMessageWrapper = this.querySelector('.back-in-stock-error-message-wrapper');
        }

        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessageWrapper.querySelector('.back-in-stock-error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      resetErrorMessages() {
        const errorMessages = this.querySelectorAll('.back-in-stock-error-message');
        const globalErrorMessageWrapper = this.querySelector('.back-in-stock-error-message-wrapper');

        errorMessages?.forEach((error) => {
          error.textContent = '';
        });

        globalErrorMessageWrapper.setAttribute('hidden', true);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      buildKlaviyoBiSPayload() {
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {},
                },
              },
              channels: [],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.dataset.variantId}`,
                },
              },
            },
          },
        };

        if (this.emailInput.value) {
          payload.data.attributes.profile.data.attributes.email = this.emailInput.value;
          payload.data.attributes.channels.push('EMAIL');
        }

        if (this.phoneInput.value && this.formattedNumber) {
          payload.data.attributes.profile.data.attributes.phone_number = this.formattedNumber;
          payload.data.attributes.channels.push('SMS');
        }

        return payload;
      }

      subscribeToKlaviyo() {
        if (!this.signupForNewsletter.checked && !this.signupForSMS.checked) {
          return;
        }

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {},
                },
              },
              custom_source: 'Back in Stock',
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'Ls53aF',
                },
              },
            },
          },
        };

        if (this.emailInput.value && this.signupForNewsletter.checked) {
          payload.data.attributes.profile.data.attributes.email = this.emailInput.value;
        }

        if (this.signupForSMS.checked && this.formattedNumber) {
          payload.data.attributes.profile.data.attributes.phone_number = this.formattedNumber;
        }

        console.log('SUBSCRIBE PAYLOAD', payload);

        var requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2025-04-15',
          },
          body: JSON.stringify(payload),
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KVDNKn', requestOptions)
          .then((result) => console.log(result))
          .catch((error) => console.log('error', error));
      }

      formatPhoneNumberForKlaviyo(input, defaultCountry = 'US') {
        try {
          const phoneNumber = new libphonenumber.parsePhoneNumber(input, defaultCountry);

          if (phoneNumber.isValid()) {
            return phoneNumber.number; // This is in E.164 format
          } else {
            return null;
          }
        } catch (error) {
          return null;
        }
      }
    },
  );
}
